/* eslint-disable better-mutation/no-mutation */

import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

type StatusState = {
    isActionsPerFullPageLoadDone: boolean;
    hasReportedViewportDiff: boolean;
    loadedLanguages: string[];
};

export const initialState: StatusState = {
    isActionsPerFullPageLoadDone: false,
    hasReportedViewportDiff: false,
    loadedLanguages: [],
};

const slice = createSlice({
    name: 'status',
    initialState,
    reducers: {
        setIsActionsPerFullPageLoadDone: (state, { payload }) => {
            state.isActionsPerFullPageLoadDone = payload;
        },
        setHasReportedViewportDiff: (state, { payload }) => {
            state.hasReportedViewportDiff = payload;
        },
        addLoadedLanguage: (state, { payload }: PayloadAction<string>) => {
            if (!state.loadedLanguages.includes(payload)) {
                state.loadedLanguages = [...state.loadedLanguages, payload];
            }
        },
    },
});

export const {
    setIsActionsPerFullPageLoadDone,
    setHasReportedViewportDiff,
    addLoadedLanguage,
} = slice.actions;

export const reducer = slice.reducer;
